import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { PasswordValidators } from '../../../../shared/components/validators/password.validators';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { InputField } from '../../../../shared/components/input-field/input-field';

@Component({
  selector: 'app-ftp-user-settings-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './ftp-user-settings-dialog.component.html',
  styleUrl: './ftp-user-settings-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtpUserSettingsDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FtpUserSettingsDialogComponent>);

  readonly data = inject<
    DialogData & {
      server: string;
      homeDir: string;
    }
  >(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  form = this.fb.nonNullable.group({
    password: [
      '',
      [
        PasswordValidators.required(),
        PasswordValidators.complexity(),
        PasswordValidators.allowedCharacters(),
        PasswordValidators.minLength(),
        PasswordValidators.maxLength(),
      ],
    ],
  });

  submit(): void {
    if (this.form.invalid) return;

    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
